module.exports = __webpack_public_path__ + "img/13_11.f3d1166c.png";